export default "__VITE_ASSET__BB7uNLE1__"